import { SET_DEALER_ACCOUNT_DETAILS } from "../action";
import { dealerAccount } from "./initial-store";

const initialState = dealerAccount;

function dealerAccountDetailsReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_DEALER_ACCOUNT_DETAILS:
      newState = action.payload;
      return newState;
    default:
      return state;
  }
}

export default dealerAccountDetailsReducer;
